import { blue, grey } from '@mui/material/colors';

const API_BASE_URL = window.ApiLink || process.env.REACT_APP_DEBUG_API_LINK;
//const API_BASE_URL = window.ApiLink || 'https://vokleeyadevapi.azurewebsites.net/api/';
const B2C_UsersOfflinePeriod = +window.UsersOfflinePeriod || 20;
const blue700 = blue[500];
const grey700 = grey[700];
const Constants = {};

Constants.API_BASE_URL = API_BASE_URL;
Constants.B2C_UsersOfflinePeriod = B2C_UsersOfflinePeriod;
Constants.VERSION_URL = `${API_BASE_URL}version`;
Constants.LOGIN_URL = `${API_BASE_URL}token`;
Constants.LOGOUT_URL = `${API_BASE_URL}user/logout`;
Constants.USER_INFO_URL = `${API_BASE_URL}user/info`;
Constants.ALERT_SEVERITY_TYPE_URL = `${API_BASE_URL}alertseveritytype`;
Constants.USER_ALERT_SETTINGS_UPDATE_URL = `${API_BASE_URL}analytics/useralertsettingsupdate`;
Constants.SYSTEM_ALERT_CONFIG_LIST_URL = `${API_BASE_URL}analytics/rtanalyticsconfiglist`;
Constants.SYSTEM_ALERT_CONFIG_UPDATE_URL = `${API_BASE_URL}analytics/rtanalyticsconfigupdate`;
Constants.INSTRUMENTS_URL = `${API_BASE_URL}instruments`;
Constants.INSTRUMENT_LOGBOOK_URL = `${API_BASE_URL}instrument/logbook`;
Constants.FLEETS_URL = `${API_BASE_URL}fleets`;
Constants.INSTRUMENT_STATE_TYPES_URL = `${API_BASE_URL}instrumentstatetype`;
Constants.USERS_ACCOUNTS_URL = `${API_BASE_URL}users`;
Constants.USERSETTINGS_URL = `${API_BASE_URL}usersettings`;
Constants.SYSTEM_SETTINGS_URL = `${API_BASE_URL}systemsettings`;
Constants.FILE_TRANSFER_URL = `${API_BASE_URL}filetransfer`;
Constants.REGIONS_URL = `${API_BASE_URL}regions`;
Constants.OLDREPORTS_URL = `${API_BASE_URL}reports/oldreport`;
Constants.REPORTS_URL = `${API_BASE_URL}reports/report`;
Constants.CACHED_REPORTS_URL = `${API_BASE_URL}reports/cachedreport`;
Constants.REPORTSLIST_URL = `${API_BASE_URL}reports/reportlist`;
Constants.FLEET_REPORTSLIST_URL = `${API_BASE_URL}reports/fleetreportlist`;
Constants.PASSWORD_URL = `${API_BASE_URL}password`;
Constants.LESSER_ROLES_URL = `${API_BASE_URL}lesserroles`;
Constants.ROLES_URL = `${API_BASE_URL}roles`;
Constants.PERMISSIONS_URL = `${API_BASE_URL}permissions`;
Constants.USERPERMISSIONS_URL = `${API_BASE_URL}userpermissions`;
Constants.ROLEPERMISSIONS_URL = `${API_BASE_URL}rolepermissions`;
Constants.USER_URL = `${API_BASE_URL}user`;
Constants.GROUPS_URL = `${API_BASE_URL}groups`;
Constants.CHAT_URL = `${API_BASE_URL}chat`;
Constants.DESKTOP_SHARING_URL = `${API_BASE_URL}desktopsharing`;
Constants.USER_AUDIT_LOGS_URL = `${API_BASE_URL}userauditlogs`;
Constants.UPDATE_PACKAGES_URL = `${API_BASE_URL}updatepackages`;
Constants.USER_REGION = `${API_BASE_URL}user/region`;
Constants.DEPLOY_PACKAGES_URL = `${API_BASE_URL}deployment`;
Constants.DEPLOYMENT_JOBS_URL = `${API_BASE_URL}deploymentjobs`;
Constants.USER_ALERTS_URL = `${API_BASE_URL}useralerts`;

Constants.HELP_BASE_URL = `${window.location.origin}/OnlineHelp/`;
Constants.HELPLIST_URL = `${Constants.HELP_BASE_URL}helpmapping.json`;

Constants.SCRIPTS_BASE_URL = `${window.location.origin}/scripts/`;
Constants.JQUERY_URL = `${Constants.SCRIPTS_BASE_URL}jquery-1.6.4.min.js`;
Constants.SIGNALR_SCRIPT_URL = `${Constants.SCRIPTS_BASE_URL}jquery.signalR-2.4.3.min.js`;
Constants.SIGNALR_PROXYSCRIPT_URL = `${API_BASE_URL}signalr/hubs`;
Constants.SIGNALR = `${API_BASE_URL}signalr`;

Constants.Roles = { Admin: 4 };

Constants.DEFAULT_ERROR_MESSAGE = 'Something went wrong.';
Constants.DATEFROM_AFTER_DATETO_ERROR_MESSAGE =
  'Invalid date. Date from cannot be after date to. Please change selection of dates before continuing.';
Constants.DATETO_BEFORE_DATEFROM_ERROR_MESSAGE =
  'Invalid date. Date to cannot be before date from. Please change selection of dates before continuing.';
Constants.NO_SELECTION_AVAILABLE = 'No selection available.';
Constants.ZERO_RESULTS = 'The applied filter matches zero results.';
Constants.MORE_THAN_CONFIGURED_RESULTS =
  'The applied filter matches more results than the configured maximum. Narrow the filter.';

Constants.SNACKBAR_TIMEOUT = 10000;
Constants.SNACKBAR_MESSAGE_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  DEFAULT: 'default',
};

Constants.COLORS = {
  ERROR: '#ff0000',
  SUCCESS: '#00cc00',
  INFO: blue700,
  WARNING: '#ff9900',
  NEUTRAL: grey700,
  PRIMARY: '#00bcd4',
  SECONDARY: '#bdbdbd',
};

Constants.MAP_SEVERITY_COLORS = {
  RED: '#ff0000',
  ORANGE: '#ff9900',
  GREEN: '#00cc00',
  GREY: grey700,
  BLACK: '#000000',
};

Constants.SETTING_KEYS = {
  DATE_FORMAT: 'DateFormat',
  NUMBER_PRECISION: 'DisplayedDecimalPlaces',
  DURATION_FORMAT: 'DurationFormat',
  ALLOWED_USER_EMAIL_DOMAINS: 'AllowedUserEmailDomains',
};

Constants.MAPS_API_KEY = window.MapsApiKey || process.env.REACT_APP_DEBUG_MAPS_API_KEY;

Constants.APPINSIGHTSKEY = window.AppInsightsKey || process.env.REACT_APP_DEBUG_APP_INSIGHT_KEY;

Constants.ADB2C_CONNECTION = {
  INSTANCE: window.AadInstance || process.env.REACT_APP_DEBUG_AAD_INSTANCE,
  TENANT: window.Tenant || process.env.REACT_APP_DEBUG_B2C_TENANT,
  SIGN_IN_POLICY: window.SigninPolicy || process.env.REACT_APP_DEBUG_B2C_SIGN_IN_POLICY,
  RESET_PASSWORD_POLICY:
    window.ResetPasswordPolicy || process.env.REACT_APP_DEBUG_B2C_RESET_PASSWORD_POLICY,
  APPLICATION_ID: window.applicationId || process.env.REACT_APP_DEBUG_B2C_FRONTEND_APP_CLIENT_ID,
  CACHE_LOCATION: window.cacheLocation || process.env.REACT_APP_DEBUG_B2C_CACHE_LOCATION,
  MSAL_LOG_LEVEL: window.msalLogLevel || 'info',
  SCOPES: window.scopes
    ? window.scopes.split(',')
    : process.env.REACT_APP_DEBUG_B2C_SCOPES.split(','),
};

Constants.ADB2C_RESET_PASSWORD_LINK = `${Constants.ADB2C_CONNECTION.INSTANCE}/${
  Constants.ADB2C_CONNECTION.TENANT
}/oauth2/v2.0/authorize?p=${Constants.ADB2C_CONNECTION.RESET_PASSWORD_POLICY}&client_id=${
  Constants.ADB2C_CONNECTION.APPLICATION_ID
}&nonce=defaultNonce&redirect_uri=https%3A%2F%2F${window.location.origin.slice(
  8
)}%2F&scope=openid&response_type=id_token&prompt=login`;

Constants.FILE_TRANSFER_MAX_SIZE_MB = window.FileTransferMaxSizeMB || 2000;

export default Constants;
